import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-add-reaction',
  templateUrl: './icon-add-reaction.component.html',
  styleUrls: ['./icon-add-reaction.component.scss']
})
export class IconAddReactionComponent implements OnInit {
  @Input() color = '#262628';
  @Input() size = 40;

  constructor() { }

  ngOnInit() {
  }

}
